
import React, { memo, ReactNode } from 'react';

interface StableEditorContainerProps {
  children: ReactNode;
  className?: string;
  height?: string;
}

export const StableEditorContainer = memo(function StableEditorContainer({ 
  children, 
  className = '',
  height = 'auto'
}: StableEditorContainerProps) {
  return (
    <div 
      className={`stable-editor-container ${className}`}
      style={{
        position: 'relative',
        width: '100%',
        minHeight: height,
        height: 'auto',
        overflowY: 'visible', // Allow content to be visible and scrollable
        contain: 'style',
        display: 'flex',
        flexDirection: 'column',
        willChange: 'opacity',
        backfaceVisibility: 'hidden',
        transition: 'opacity 0.3s ease-in-out',
        transform: 'translateZ(0)', // Force GPU acceleration
      }}
    >
      {children}
    </div>
  );
});
